import { useState } from "react";
import { Button } from "@/components/ui/button";

const PAUSE_OPTIONS = [
  { label: "2 weeks", days: 14 },
  { label: "1 month", days: 30 },
  { label: "3 months", days: 90 },
] as const;

interface ReminderPausePanelProps {
  loading: boolean;
  onPause: (days: number) => void;
  onTurnOff: () => void;
  onCancel: () => void;
  compact?: boolean;
}

const ReminderPausePanel = ({
  loading,
  onPause,
  onTurnOff,
  onCancel,
  compact = false,
}: ReminderPausePanelProps) => {
  const [selectedDays, setSelectedDays] = useState<number | null>(30);

  if (compact) {
    return (
      <div className="space-y-3">
        <div className="flex gap-2">
          {PAUSE_OPTIONS.map((opt) => (
            <button
              key={opt.days}
              onClick={() => setSelectedDays(opt.days)}
              className={`flex-1 rounded-full border py-2 text-sm transition-colors ${
                selectedDays === opt.days
                  ? "bg-[#C9A84C] text-white border-[#C9A84C]"
                  : "bg-background text-foreground border-border hover:border-foreground/30"
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
        <Button
          onClick={() => selectedDays && onPause(selectedDays)}
          disabled={!selectedDays || loading}
          className="w-full rounded-full bg-foreground text-background hover:bg-foreground/90"
          size="lg"
        >
          {loading ? "Pausing…" : "Pause and keep my account"}
        </Button>
        <button
          onClick={onTurnOff}
          disabled={loading}
          className="w-full text-sm text-muted-foreground hover:text-foreground transition-colors py-1"
        >
          Continue with deletion instead
        </button>
      </div>
    );
  }

  return (
    <div className="mt-2 border-l-[3px] border-l-[#C9A84C] p-4">
      <p className="text-sm font-bold text-foreground">
        Take a break or turn off?
      </p>
      <p className="text-xs mt-1 text-muted-foreground">
        A pause keeps your Circle safe while you step away.
      </p>

      <div className="flex gap-2 mt-3">
        {PAUSE_OPTIONS.map((opt) => (
          <button
            key={opt.days}
            onClick={() => !loading && onPause(opt.days)}
            disabled={loading}
            className={`flex-1 rounded-full border py-2 text-sm transition-colors ${
              selectedDays === opt.days
                ? "bg-[#C9A84C] text-white border-[#C9A84C]"
                : "bg-background text-foreground border-border hover:border-foreground/30"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>

      <p className="text-sm text-center mt-3" style={{ color: "#666666" }}>
        <button
          onClick={onTurnOff}
          disabled={loading}
          className="hover:text-foreground transition-colors"
        >
          Turn off entirely
        </button>
        <span> · </span>
        <button
          onClick={onCancel}
          disabled={loading}
          className="hover:text-foreground transition-colors"
        >
          Cancel
        </button>
      </p>
    </div>
  );
};

export default ReminderPausePanel;
